import { getProductionCredits } from 'utils/productions';

export const getContributors = ({ data, entity, entityType }) => {
  const productionCredits = getProductionCredits(data, {
    entityId: entity?.id,
    entityType,
  });

  return {
    credits: [
      ...(productionCredits?.cast || []).slice(0, 3),
      ...(productionCredits?.instrumentalists || []).slice(0, 3),
    ],
    directors: productionCredits?.directors,
    conductors: productionCredits?.conductors,
    producers: productionCredits?.producers,
    ensembles: productionCredits?.ensembles,
    entityRoles: productionCredits?.entityRoles,
    cast: productionCredits?.cast,
    crew: productionCredits?.crew,
    instrumentalists: productionCredits?.instrumentalists,
  };
};
